import api from '../api/apiClient'
import type { CompletePurchaseRequest, CancelPurchaseRequest, WithdrawalRequest, Transaction } from '../models/transaction'

export const paymentsRepository = {
  completePurchase: async (data: CompletePurchaseRequest): Promise<Transaction> => {
    const response = await api.post('/payments/complete-purchase', data)
    return response.data.data
  },

  cancelPurchase: async (data: CancelPurchaseRequest): Promise<Transaction> => {
    const response = await api.post('/payments/cancel-purchase', data)
    return response.data.data
  },

  requestWithdrawal: async (data: WithdrawalRequest): Promise<Transaction> => {
    const response = await api.post('/payments/request-withdrawal', data)
    return response.data.data
  }
}